import '../media/css/AppBody.css';
import React from 'react';
import NuovaPrenotazione from "./Body/NuovaPrenotazione.mjs";
import EditPrenotazione from "./Body/EditPrenotazione.mjs";
import TablePrenotazioni from "./Body/TablePrenotazioni.mjs";

const AppBody = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			operation: props?.operation || 'index',
			operationData: props?.operationData
		};
		this.contentChooser = this.contentChooser.bind(this);
		this.uid = "AppBody-"+window.glob.generateUid();
	}

	componentDidMount() {
		window.glob.register('operation',(o,d)=> {
			this.setState({ operation: o, operationData: d });
		}, this.uid );
	}

	componentWillUnmount() {
		window.glob.unregister(['operation'], this.uid );
	}
	contentChooser(op,opData) {
		switch ( op ?? this.state.operation ) {
			case 'newP' : return <NuovaPrenotazione data={opData ?? this.state.operationData} />;
			case 'editP' : return <EditPrenotazione data={opData ?? this.state.operationData} />;
			default : return <TablePrenotazioni data={opData ?? this.state.operationData} />;
		}
	}
	render() {
		return(
			<div className={"AppBody"} id={this.uid}>
				{ this.contentChooser(this.state.operation,this.state.operationData) }
			</div>
		);
	}
}

export default AppBody;